export default {
  computed: {
    templateId () {
      return this.$store.getters.windowData(this.windowId).contentId
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/template-id.js